
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.875 15.3l-6.6-6.6a.883.883 0 01-.213-.325A1.115 1.115 0 010 8c0-.133.02-.258.062-.375A.883.883 0 01.275 7.3l6.6-6.6a.978.978 0 01.687-.288.933.933 0 01.713.288c.2.183.304.412.313.687A.933.933 0 018.3 2.1L3.4 7h11.175a.97.97 0 01.713.287.97.97 0 01.287.713c0 .283-.096.52-.287.712a.968.968 0 01-.713.288H3.4l4.9 4.9c.183.183.28.417.288.7a.872.872 0 01-.288.7c-.183.2-.417.3-.7.3a.988.988 0 01-.725-.3z","fill":"#999"}})])
          )
        }
      }
    